import React, { useState, useEffect, useContext } from 'react'
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LightBox from 'components/LightBox';
import { useForm } from "react-hook-form";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { GlobalContext } from 'store/context/GlobalContext';
import { addExchange } from 'services/authService';
import useGa from 'hooks/useGa';
import { AttrText } from 'components/AttrText';

const Step2 = (props) => {
    const gaTracking = useGa();
    const history = useHistory();
    const { formData, setForm, awardsData, fetchawardsData, navigation } = props;
    const { previous } = navigation;
    const context = useContext(GlobalContext);
    const { userData, setUserData, setLoader } = context;
    const { handleSubmit, reset, setValue, formState: { isDirty, isValid, errors }, register } = useForm({ mode: 'onChange', shouldUnregister: true });
    const user = useSelector((state) => state.Auth.user);
    const [ checkboxToggle, setCheckboxToggle ] = useState(false);
    const [ giveawaySuccessLightbox, setGiveawaySuccessLightbox ] = useState(false);
    const [ giveawayNotEnoughLightbox, setGiveawayNotEnoughLightbox ] = useState(false);
    const [ pointsLightbox, setPointsLightbox ] = useState(false);
    const [ inputLightbox, setInputLightbox ] = useState(false);
    const [ checkboxLightbox, setCheckboxLightbox ] = useState(false);
    const [ tableData, setTableData ] = useState([]);
    const [ totalPoints, setTotalPoints ] = useState(0);
    
    useEffect(() => {
        reset({
            form_name: userData.form_name,
            form_email: userData.form_email,
            form_phone: userData.form_phone,
            form_address: userData.form_address,
        })
    }, [userData])

    useEffect(() => {
        let totalPoints = 0;
        let renderData = [];
        renderData = formData.exchange_list.map((item) =>
            {
                return ({
                    awards_id: item.awards_id,
                    awards_item: awardsData.find(e => e.awards_id === item.awards_id).awards_item,
                    exchange_nu: item.exchange_nu,
                    requirePoints: awardsData.find(e => e.awards_id === item.awards_id).awards_points*item.exchange_nu,
                    awards_nu_check: true,
                })
            }
        )
        if(renderData.length > 0){
            totalPoints = renderData.map((item) => item.requirePoints).reduce(function(total, e){
                return total + e;
            });
        }
        setTableData(renderData);
        setTotalPoints(totalPoints);
    }, [formData])

    const onSubmit = (data) => {
        gaTracking("giveaway-step2-submit");
        if(data.form_name === "" || data.form_phone === "" || data.form_email === "" || data.form_address === ""){
            setInputLightbox(true);
            return;
        }

        if(!checkboxToggle){
            setCheckboxLightbox(true);
            return;
        }

        let result = {
            ...formData, ...data
        }

        const finalData = new FormData();
        Object.keys(result).map(function(key) {
            if(Array.isArray(result[key])){
                for(let i = 0; i< result[key].length; i++){
                    Object.keys(result[key][i]).map(function(key2){
                        finalData.append(`${key}[${i}][${key2}]`,result[key][i][key2]);
                    })
                }
            }else{
                return finalData.append(key, result[key]);
            }
        });

        setLoader(true);
        addExchange(finalData).then(res => {
            fetchawardsData();
            setTimeout(() => {
                if(res.result){
                    setLoader(false);
                    setGiveawaySuccessLightbox(true);
                    setUserData({
                        ...userData,
                        exchange_list: res.exchange_list,
                        user_last_points: res.user_last_points,
                        user_points: res.user_points,
                        user_used_points: res.user_used_points,
                        ...data,
                    })
                }else{
                    if(res.end){
                        //活動結束
                        setLoader(false);
                        alert(res.msg);
                        return;
                    }
                    if(!res.point_check){
                        setLoader(false);
                        setPointsLightbox(true);
                        return;
                    }
                    if(!res.award_check){
                        setLoader(false);
                        setGiveawayNotEnoughLightbox(true);
                        let arr = Array.from(tableData);
                        arr = arr.map((item) =>
                            {
                                return ({
                                    ...item,
                                    awards_nu_check: res.exchange_check.find(e => e.awards_id === item.awards_id).awards_nu_check
                                })
                            }
                        )
                        setTableData(arr);
                        return;
                    }
                }
            }, 500)
        })
    }

    const handlePrevious = () => {
        gaTracking("giveaway-step2-submit-success2");
        setForm({
            target: {
                name: 'exchange_list',
                value: [],
            }
        })
        previous();
    }

    return (
        <div className="inner-container step2">
            <AttrText className="name" text={user.login_name}>{user.login_name}</AttrText>
            <div className="giveaway-record">
                <div className="title giveaway-step2-text1"></div>
                <div className="table-responsive">
                    <table className="record-table">
                        <thead>
                            <tr>
                                <th>
                                    <div>兌換項目</div>
                                </th>
                                <th>
                                    <div>兌換數量</div>
                                </th>
                                <th>
                                    <div>點數小計</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                tableData.map((item, index) =>
                                    <tr key={index}>
                                        <td>{item.awards_item}</td>
                                        <td>{item.exchange_nu}</td>
                                        <td>{item.requirePoints}點</td>
                                    </tr>
                                )
                            }
                            <tr>
                                <td></td>
                                <td></td>
                                <td>總計{totalPoints}點</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="form-container">
                <div className="title giveaway-step2-text2"></div>
                <form onSubmit={handleSubmit(onSubmit)} className="giveaway-form">
                    <div className="giveaway-form-group">
                        <label>姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</label>
                        <input
                            tabIndex="1"
                            className={errors.form_name ? 'error' : ''}
                            name="form_name"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_name", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空',
                                },
                                pattern: {
                                    value: /^[\u4e00-\u9fa5]+$/i,
                                    message: '* 請填寫中文姓名',
                                },
                            })}
                        />
                    </div>
                    { errors.form_name && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_name.message}</div> }
                    <div className="giveaway-form-group">
                        <label>聯絡電話</label>
                        <input
                            tabIndex="1"
                            className={errors.form_phone ? 'error' : ''}
                            name="form_phone"
                            pattern="[0-9]*"
                            type="text"
                            maxLength="10"
                            inputMode="numeric"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_phone", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空 (限定數字)',
                                },
                                pattern: {
                                    value: /\d{2,4}-?\d{3,4}-?\d{3,4}#?(\d+)?/g,
                                    message: '* 聯絡電話格式不正確',
                                },
                                onChange: (e) => setValue("form_phone", e.target.value.replace(/\D/g,'')),
                                onWheel: (e) => e.target.blur(),
                                onPaste: (e) => e.preventDefault(),
                            })}
                        />
                    </div>
                    { errors.form_phone && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_phone.message}</div> }
                    <div className="giveaway-form-group">
                        <label>電子信箱</label>
                        <input
                            tabIndex="1"
                            className={errors.form_email ? 'error' : ''}
                            name="form_email"
                            type="text"
                            inputMode="email"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_email", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空',
                                },
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: '* 信箱格式不正確',
                                },
                            })}
                        />
                    </div>
                    { errors.form_email && <div className="font-size-14 text-danger text-left mgt-1 mgb-4" style={{marginLeft: "80px"}}>{errors.form_email.message}</div> }
                    <div className="giveaway-form-group">
                        <label>寄送地址</label>
                        <input
                            tabIndex="1"
                            className={errors.form_address ? 'error' : ''}
                            name="form_address"
                            type="text"
                            autoComplete="off"
                            spellCheck="false"
                            {...register("form_address", {
                                required: {
                                    value: true,
                                    message: '* 欄位不可為空',
                                },
                                minLength: {
                                    value: 8,
                                    message: '* 寄送地址字數最少8個字元',
                                }
                            })}
                        />
                    </div>
                    { errors.form_address && <div className="font-size-14 text-danger text-left mgt-1" style={{marginLeft: "80px"}}>{errors.form_address.message}</div> }
                    <div className="content-box">
                        <div className="content">
                            <div className="title giveaway-step2-text3"></div>
                            <div className="desc">
                                <div>※ 敬請妥善保留全部已登錄序號之瓶貼紙本，以供活動單位審核。</div>
                                <div>※ 獎品兌換申請後，系統將寄送審核步驟至您的電子信箱，請依照信件指示完成審核流程，活動單位於活動結束後寄出獎品。</div>
                                <div>※ 敬請確認以上收件資料是否填寫正確，如因資料錯誤無法順利寄送獎品，或收取審核信件，視為放棄。</div>
                            </div>
                        </div>
                    </div>
                    <div className="mgy-4 text-center">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="agree"
                                    size="small"
                                    checked={checkboxToggle}
                                    value="checked"
                                    onChange={() => setCheckboxToggle(!checkboxToggle)}
                                />
                            }
                            label={
                                <div className="font-size-14 font-family-notosans">
                                    我已閱讀並同意<Link to="/activity" target="_blank" className="text-decoration-underline fw-bold">活動辦法及隱私權規範</Link>
                                </div>
                            }
                            sx={{margin: "0 0 0 -10px"}}
                        />
                    </div>
                    <div className="button-container">
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step2-back");
                                previous();
                            }}
                        >
                            返回修改
                        </button>
                        <button type="submit" className="common-btn yellow">確認兌換</button>
                    </div>
                </form>
            </div>

            <LightBox
                open={giveawaySuccessLightbox}
                callback={() => setGiveawaySuccessLightbox(false)}
                className="giveaway-success-light-box"
            >
                <div className="light-box-header giveaway-success"></div>
                <div className="light-box-body text-center">
                    <div className="text mb">
                        <div>敬請留意電子信箱，完成審核兌獎流程，才收得到獎品唷！請至「獎品兌換紀錄」頁面，查看審核進度。</div>
                    </div>
                    <div className="text pc">
                        <div>敬請留意電子信箱，完成審核兌獎流程，才收得到獎品唷！</div>
                        <div>請至「獎品兌換紀錄」頁面，查看審核進度。</div>
                    </div>
                    <div className="button-container mgb-8">
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step2-submit-success1");
                                setGiveawaySuccessLightbox(false);
                                setTimeout(() => {
                                    history.push("/serial-number#giveaway");
                                }, 0);
                            }}
                        >
                            獎品兌換紀錄
                        </button>
                        <button type="button" className="common-btn yellow" onClick={handlePrevious}>繼續兌換</button>
                    </div>
                </div>
            </LightBox>

            <LightBox
                open={giveawayNotEnoughLightbox}
                callback={() => setGiveawayNotEnoughLightbox(false)}
                cross
            >
                <div className="light-box-header giveaway-not-enough"></div>
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>{`【${tableData.filter(e => e.awards_nu_check === false).map((item) => item.awards_item).join("】、【")}】`}獎品剩餘數量不足，請重新選取欲兌換項目</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("giveaway-step2-award-error");
                            setGiveawayNotEnoughLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>

            <LightBox
                open={pointsLightbox}
                callback={() => setPointsLightbox(false)}
                cross
            >
                <div className="light-box-header points-not-enough"></div>
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>多買幾瓶，集滿點數來兌換吧。</div>
                    </div>
                    <div className="button-container mgb-8">
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step2-points-error1");
                                setPointsLightbox(false);
                            }}
                        >
                            返回確認
                        </button>
                        <button
                            type="button"
                            className="common-btn yellow"
                            onClick={() => {
                                gaTracking("giveaway-step2-points-error2");
                                setTimeout(() => {
                                    history.push("/exchange");
                                }, 0)
                            }}
                        >
                            輸入序號
                        </button>
                    </div>
                </div>
            </LightBox>

            <LightBox
                open={inputLightbox}
                callback={() => setInputLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請先填寫完整收件資料</div>
                    </div>
                    <button type="button" className="common-btn yellow mgb-8" onClick={() => setInputLightbox(false)}>確認</button>
                </div>
            </LightBox>

            <LightBox
                open={checkboxLightbox}
                callback={() => setCheckboxLightbox(false)}
                className="custom-light-box"
                cross
            >
                <div className="light-box-body text-center">
                    <div className="text">
                        <div>請閱讀並勾選活動辦法及隱私權規範</div>
                    </div>
                    <button
                        type="button"
                        className="common-btn yellow mgb-8"
                        onClick={() => {
                            gaTracking("giveaway-step2-agree-error");
                            setCheckboxLightbox(false);
                        }}
                    >
                        確認
                    </button>
                </div>
            </LightBox>
        </div>
    )
}

export default Step2;